export function addPx(num: number): string {
  return `${num}px`;
}

export function getItemTestId(
  index: number,
  itemTestId: string | ((index: number) => string) | undefined,
): string | null {
  if (!itemTestId) {
    return null;
  }

  return typeof itemTestId === 'function' ? itemTestId(index) : itemTestId;
}
